<template>
    <div class="locator__container">
        <div class="pagePart pagePart--no-top-offset">
            <div class="locator">
                <slot/>
                <locator-map v-bind="$props" v-if="displayMap"/>
            </div>
        </div>
        <div class="siteFooterBeforeSpace"></div>
    </div>
</template>

<script>
    import LocatorMap from './Map';

    export default {
        name: 'LocatorContainer',
        components: {
            LocatorMap
        },
        props: {
            title: String,
            displayMap: {
                default: true,
                type: Boolean,
            },
            onPinClick: {
                type: Function | null,
                default: null,
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/locator/LocatorContainer.vue